import { eventType } from './eventTypes';

export const Clear = () => {

  return {
    event:eventType.Clear,
    ecommerce:null
  }
}